<template>
<!-- PC端 -->
<div class="header_box" v-if="isPC">
  <div class="content">
    <H1 class="logo">
      <img @click="goHomePage('Homepage', 'Homepage')" src="../../assets/icon/ep_02.png" alt="EPGroup" title="EPGroup" class="logo_bg">
    </H1>
    <div class="nav_list">
      <ul class="first_box">
        <li class="item" 
          v-for="(firstNav, index) in evenPc(navList)" :key="index"
          :class="{ active: isActive === firstNav.listUrl }">
          <p class="title_single" 
            v-if="firstNav.children.length === 0"
            @click="switchPage(firstNav)">{{firstNav.name}}</p>
          <p class="title" v-else>{{firstNav.name}}</p>
          <ul class="second_box" v-if="firstNav.children.length > 1">
            <li class="list" 
            v-for="(item, index) in even(firstNav.children)" 
            :key="index"
            @click="switchPage(item)">{{item.name}}</li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="right_tools">
      <div class="contact" @click="openContact" v-if="navList.length > 0">{{evenContact(navList)}}</div>
      <div class="language" @click="switchLangPopup">{{curLangName}}</div>
      <ul class="language_list" v-if="langPopupStatus">
        <li class="item" 
        v-for="(item, index) in languageList" 
        :key="index"
        @click="setCurLanguage(item)">{{item.name}}</li>
      </ul>
    </div>
  </div>
</div>
<!-- 移动端 -->
<div class="mobile_header_box" v-else>
  <div class="logo_box" @click="goHomePage('Homepage', 'Homepage')">
    <img src="@/assets/mobile/home_03.png" alt="logo">
  </div>
  <div class="right_box">
    <div class="language_box" @click="switchLangPopup">{{curLangName}}</div>
    <div class="nav_icon" @click="switchNavPopup"></div>
  </div>
  <!-- nav layer -->
  <div class="popup_nobg_box" v-if="navPopupStatus">
    <div class="nav_content">
      <div class="top_bar">
        <div class="m_icon_close" @click="switchNavPopup"></div>
      </div>
      <div class="nav_list">
        <ul class="first_box">
          <li class="item" 
          v-for="(firstNav, index) in navList" :key="index"
          :class="{ active: isActive === firstNav.listUrl, curHeight: mobileNavStatus && isActive === firstNav.listUrl }">
            <p class="title_single" 
            v-if="firstNav.children.length === 0"
            @click="switchPage(firstNav)">{{firstNav.name}}</p>
            <p class="title"
            v-if="firstNav.children.length > 1"
            @click="openSecondNav(firstNav.listUrl)">{{firstNav.name}}</p>
            <ul class="second_box" v-if="firstNav.children.length > 1">
              <li class="list" 
              v-for="(item, index) in even(firstNav.children)" 
              :key="index"
              :class="{curpath: currentPath === item.infoUrl}"
              @click="switchPage(item)">{{item.name}}</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- language layer -->
  <div class="popup_nobg_box" v-if="langPopupStatus">
    <div class="nav_content">
      <div class="top_bar">
        <div class="m_icon_close" @click="switchLangPopup"></div>
      </div>
      <ul class="language_list">
        <li class="lang_item" 
        v-for="(item, index) in languageList" :key="index"
        :class="{ active: language === item.code }"
        @click="setCurLanguage(item)">{{item.name}}</li>
      </ul>
    </div>
  </div>
  <!-- contact us layer -->
  <div class="popup_nobg_box" v-if="contactPopupStatus">
    <div class="contact_content">
      <div class="top_bar">
        <div class="m_icon_close" @click="switchContactPopup"></div>
      </div>
      <div class="text_content_box">
        <div class="title_box">{{pageName.title}}</div>
        <div class="item_state_list">
          <ul class="img_box">
            <li class="item_img">
              <img src="@/assets/mobile/flag_03.png" alt="CN">
              <p class="name">{{pageName.cn}}</p>
            </li>
          </ul>
          <div class="factory_list">
            <p class="factory_name">{{EVN.sname}}</p>
            <p class="addr">{{EVN.address}}</p>
            <p class="phone">{{EVN.telephone}}</p>
          </div>
          <div class="factory_list">
            <p class="factory_name">{{EVH.sname}}</p>
            <p class="addr">{{EVH.address}}</p>
            <p class="phone">{{EVH.telephone}}</p>
          </div>
        </div>
        <div class="item_state_list">
          <ul class="img_box">
            <li class="item_img">
              <img src="@/assets/mobile/flag_06.png" alt="CN">
              <p class="name">{{pageName.vn}}</p>
            </li>
            <li class="item_img kh">
              <img src="@/assets/mobile/flag_08.png" alt="CN">
              <p class="name">{{pageName.kh}}</p>
            </li>
          </ul>
          <div class="factory_list">
            <p class="factory_name">{{EVM.sname}}</p>
            <p class="addr">{{EVM.address}}</p>
            <p class="phone">{{EVM.telephone}}</p>
          </div>
          <div class="factory_list">
            <p class="factory_name">{{EVC.sname}}</p>
            <p class="addr">{{EVC.address}}</p>
            <p class="phone">{{EVC.telephone}}</p>
          </div>
        </div>
        <div class="item_state_list">
          <ul class="img_box">
            <li class="item_img">
              <img src="@/assets/mobile/flag_12.png" alt="CN">
              <p class="name">{{pageName.id}}</p>
            </li>
          </ul>
          <div class="factory_list">
            <p class="factory_name">{{PRB.sname}}</p>
            <p class="addr">{{PRB.address}}</p>
            <p class="phone">{{PRB.telephone}}</p>
          </div>
          <div class="factory_list">
            <p class="factory_name">{{PBB.sname}}</p>
            <p class="addr">{{PBB.address}}</p>
            <p class="phone">{{PBB.telephone}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
// api
import { mapState } from 'vuex'
import StorageService from '@/services/storage.service';

export default {
  name: 'myHeader',
  props: {
    navList: { type: Array, default: () => {} },
    languageList: { type: Array, default: () => {} },
    factoryList: { type: Array, default: () => {} },
  },
  data() {
    return {
      // 英语 中文 越南语 柬埔寨语 印尼语
      userLangList: ['EN', 'CN', 'VN', 'KH', 'ID'],
      isActive: '',
      mobileNavStatus: false,
      curLangName: '',
      navPopupStatus: false,
      langPopupStatus: false,
      contactPopupStatus: false,
      EVN: '',
      EVH: '',
      EVM: '',
      EVC: '',
      PRB: '',
      PBB: '',
      pageName: '',
      pageName_cn: {
        title: '联系我们',
        cn: '中国',
        vn: '越南',
        kh: '柬埔寨',
        id: '印尼',
      },
      pageName_en: {
        title: 'Contact Us',
        cn: 'CN',
        vn: 'VN',
        kh: 'KH',
        id: 'ID',
      },
    }
  },
  computed: mapState({
     ...mapState(['activeName', 'isPC', 'language', 'LangIndex', 'currentPath'])
  }),
  watch: {
    activeName: {
      immediate: true,
      handler(str) {
        this.isActive = str;
      },
    },
    factoryList: {
      immediate: false,
      handler(arr) {
        this.initFactory();
      },
    },
    languageList: {
      immediate: false,
      handler(arr) {
        this.curLangName = this.getCurLangName(arr, this.language)[0].name;
      },
    },
    LangIndex: {
      handler(str) {
        this.initLang();
      },
    },
  },
  created() {
    // console.log(this.$route.name);
  },
  
  mounted() {
    this.initLang();
    // console.log(this.$route.name);
  },
  methods: {
    initLang() {
      if (this.LangIndex === 1) {
        this.pageName = this.pageName_cn;
      } else {
        this.pageName = this.pageName_en;
      };
    },
    getCurLangName(numbers, code) {
      return numbers.filter(function (number) {
        return number.code === code
      })
    },
    // 回首页
    goHomePage(pageName, navName) {
        if (pageName === this.$route.path) {
          return false;
        }
        this.navPopupStatus = false;
        this.$tools.go(pageName);
    },
    // 切换页面
    switchPage(page) {
      if (page.listUrl === 'Gallery') {
        this.$tools.go({
          name: page.listUrl,
          params: {
            factoryName: page.infoUrl,
          },
        });
      } else {
        if (page.listUrl === 'Contact') {
          this.switchContactPopup();
        } else {
          this.$tools.go(page.infoUrl);
        }
      }
      this.navPopupStatus = false;
    },
    // 设置语言
    setCurLanguage(item) {
      this.curLangName = item.name;
      const langIndex = this.userLangList.indexOf(item.code);
      this.$store.commit("setLanguage", item.code);
      this.$store.commit("setLangIndex", langIndex);
      StorageService.setCurLang(item.code);
      StorageService.setCurIndex(langIndex);
      this.langPopupStatus = false;
      // console.log('switch language: ', item.code);
      // console.log('switch LangIndex: ', langIndex);
    },
    // 移动端开启二级导航
    openSecondNav(navName) {
      if (this.isActive === navName) {
        this.mobileNavStatus = !this.mobileNavStatus;
      } else {
        this.isActive = navName;
        this.mobileNavStatus = true;
      }
    },
    // 切换导航弹层
    switchNavPopup() {
      this.navPopupStatus = !this.navPopupStatus;
    },
    // 切换语言弹层
    switchLangPopup() {
      this.langPopupStatus = !this.langPopupStatus;
    },
    // mobile 切换联系我们弹层
    switchContactPopup() {
      this.contactPopupStatus = !this.contactPopupStatus;
    },
    // pc-打开联系我们
    openContact() {
      this.$emit('open');
    },
    // 初始化
    initFactory() {
      this.EVN = this.evenFactory(this.factoryList, 'EVN')[0];
      this.EVH = this.evenFactory(this.factoryList, 'EVH')[0];
      this.EVM = this.evenFactory(this.factoryList, 'EVM')[0];
      this.EVC = this.evenFactory(this.factoryList, 'EVC')[0];
      this.PRB = this.evenFactory(this.factoryList, 'PRB')[0];
      this.PBB = this.evenFactory(this.factoryList, 'PBB')[0];
    },
    // 数据过滤
    evenFactory(numbers, target) {
      return numbers.filter(function (number) {
        return number.sname === target
      })
    },
    // 数据过滤
    even(numbers) {
      return numbers.filter(function (number) {
        return number.state === 1
      })
    },
    // 数据过滤
    evenLang(numbers) {
      return numbers.filter(function (number) {
        return number.isDefault === 1
      })
    },
    // 数据过滤
    evenPc(numbers) {
      return numbers.filter(function (number) {
        return number.listUrl !== 'Contact'
      })
    },
    // 数据过滤
    evenContact(numbers) {
      return numbers.filter(function (number) {
        return number.listUrl === 'Contact'
      })[0].name
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header_box{
  width: 100%;
  height: 82px;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 899;
  .content{
    width: 1200px;
    margin: 0 auto;
  }
  .logo{
    width: 230px;
    height: 82px;
    float: left;
    overflow: hidden;
    .logo_bg{
      width: 130px;
      height: 82px;
      overflow: hidden;
      cursor: pointer;
    }
  }
  .nav_list{
    padding-top: 38px;
    font-size: 14px;
    color: #989898;
    float: left;
    .first_box{
      display: block;
      .item{
        height: 44px;
        line-height: 44px;
        padding: 0 16px;
        text-align: center;
        cursor: pointer;
        position: relative;
        float: left;
        &.active{
          color: #1374b2;
        }
        .second_box{
          padding: 10px 0;
          background-color: rgba(255, 255, 255, .8);
          overflow: hidden;
          position: absolute;
          top: 44px;
          left: 0;
          z-index: 3;
          display: none;
          .list{
            width: 200px;
            padding: 0 20px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            color: #3f3f3f;
            text-align: left;
            cursor: pointer;
          }
          .list:hover{
            color: #fff;
            background-color: #1b79b5;
          }
          &.w140{
            width: 140px;
          }
          &.w120{
            width: 120px;
          }        
        }
      }
      .item:hover{
        color: #1374b2;
        background-color: #f3f3f3;
        .second_box{
          display: block;
        }
      }
    }
  }
  .right_tools{
    min-width: 160px;
    height: 20px;
    padding: 50px 20px 12px 0;
    position: relative;
    float: right;
    .contact{
      min-width: 60px;
      padding: 0 18px;
      font-size: 14px;
      line-height: 20px;
      color: #0f4267;
      background-position: left;
      background-repeat: no-repeat;
      background-image: url(../../assets/icon/ep_05.png);
      background-size: 12px;
      cursor: pointer;
      overflow: hidden;
      float: left;
    }
    .language{
      padding-left: 18px;
      padding-right: 16px;
      font-size: 14px;
      line-height: 20px;
      color: #717070;
      background-position: left;
      background-repeat: no-repeat;
      background-image: url(../../assets/icon/ep_07.gif);
      background-size: 12px 13px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      float: right;
      &::after{
        content: '';
        display: block;
        width: 7px;
        height: 4px;
        background-position: left;
        background-repeat: no-repeat;
        background-image: url(../../assets/icon/ep_10.gif);
        background-size: 7px 4px;
        position: absolute;
        right: 0;
        top: 8px;
      }
    }
    .language_list{
      width: 100%;
      padding: 15px 0;
      background-color: rgba($color: #fff, $alpha: 0.9);
      border: 1px solid #ccc;
      position: absolute;
      top: 91px;
      right: 10px;
      overflow: hidden;
      z-index: 99;
      .item{
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        color: #272727;
        text-align: center;
        overflow: hidden;
        cursor: pointer;
      }
      .item:hover{
        color: #fff;
        background-color: #1b79b5;
      }
    }
  }
}
.mobile_header_box{
  width: 100%;
  padding: 0 0.2rem;
  height: 0.88rem;
  box-sizing: border-box;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 899; 
  .logo_box{
    width: 1.5rem;
    height: 0.65rem;
    margin-top: 0.12rem;
    overflow: hidden;
    float: left;
  }
  .right_box{
    padding: 0.2rem 0;
    line-height: 0.48rem;
    float: right;
    .language_box{
      min-width: 2rem;
      padding-right: 0.3rem;
      font-size: 0.32rem;
      color: #767373;
      text-align: right;
      box-sizing: border-box;
      background-position: right;
      background-repeat: no-repeat;
      background-image: url(../../assets/mobile/home_09.png);
      background-size: 0.2rem 0.12rem;   
      overflow: hidden;
      float: left;
    }
    .nav_icon{
      width: 0.5rem;
      height: 0.44rem;
      margin-left: 0.3rem;
      box-sizing: border-box;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../../assets/mobile/home_06.png);
      background-size: 0.36rem 0.26rem;   
      overflow: hidden;     
      float: right;
    }
  }
  // nav layer
  .nav_content{
    width: 100%;
    height: 100%;
    background-color:rgba(255, 255, 255, 0.95);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    .top_bar{
      width: 100%;
      padding: 0.2rem 0.28rem;
      height: 0.88rem;
      box-sizing: border-box;
      overflow: hidden;
      .m_icon_close{
        width: 0.4rem;
        height: 0.4rem;
        float: right;
      }
    }    
    .nav_list{
      width: 100%;
      padding: 0 0.28rem;
      box-sizing: border-box;
      overflow: hidden;
      .item{
        width: 100%;
        height: 0.72rem;
        line-height: 0.72rem;
        font-size: 0.28rem;
        color: #272727;
        font-weight: 600;
        text-align: center;
        overflow: hidden;
        .title{
          display: inline-block;
          padding: 0 0.3rem;
          position: relative;
          overflow: auto;
        }
        .title_single{
          display: inline-block;
          padding: 0 0.3rem;
          position: relative;
          overflow: auto;          
        }
        .title:after{
          content: '';
          display: block;
          width: 0.2rem;
          height: 0.12rem;
          background-image: url(../../assets/mobile/home_09.png);
          background-size: 100%;
          background-position: center;
          background-repeat: no-repeat;
          position: absolute;
          top: 0.31rem;
          right: 0;
        }
        .second_box{
          display: none;
        }
      }
      .item.active{
        color: #1374b2;
      }
      .item.curHeight{
        height: auto;
        .title{
          display: inline;
        }
        .title:after{
          content: '';
          display: block;
          width: 0.2rem;
          height: 0.12rem;
          background-image: url(../../assets/mobile/home_08.png);
          background-size: 100%;
          background-position: center;
          background-repeat: no-repeat;
          position: absolute;
          top: 0.1rem;
          right: 0;
        }
        .second_box{
          display: block;
          font-size: 0.26rem;
          line-height: 0.68rem;
          color: #272727;
          overflow: hidden;
          .list{
            width: 100%;
            height: 0.68rem;
            font-weight: 200;
            &.curpath{
              color: #1374b2;
              font-weight: 400;
            }
          }
        }
      }
    }
    .language_list{
      width: 100%;
      padding: 0 0.28rem;
      margin-top: 2rem;
      box-sizing: border-box;
      overflow: hidden;   
      .lang_item{
        width: 100%;
        height: 0.72rem;
        line-height: 0.72rem;
        font-size: 0.28rem;
        color: #272727;
        font-weight: 600;
        text-align: center;
        overflow: hidden;
        &.active{
          color: #1374b2;
        }    
      }
    }
  }
  // contact layer
  .contact_content{
    width: 100%;
    height: 100%;
    background-color:rgba(255, 255, 255, 0.95);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    .top_bar{
      width: 100%;
      padding: 0.2rem 0.28rem;
      height: 0.88rem;
      box-sizing: border-box;
      overflow: hidden;
      .m_icon_close{
        width: 0.4rem;
        height: 0.4rem;
        float: right;
      }
    }
    .text_content_box{
      width: 100%;
      height: calc(100% - 0.88rem);
      padding: 0.2rem;
      box-sizing: border-box;
      overflow-y: scroll;
      .title_box{
        width: 100%;
        line-height: 0.6rem;
        font-size: 0.5rem;
        font-weight: 600;
        color: #272727;
        overflow: hidden;
      }
      .item_state_list{
        width: 100%;
        margin-top: 0.2rem;
        overflow: hidden;
        .img_box{
          width: 100%;
          padding: 0.2rem 0;
          overflow: hidden;
          .item_img{
            width: 0.72rem;
            margin-right: 0.5rem;
            float: left;
            .name{
              width: 100%;
              height: 0.48rem;
              line-height: 0.48rem;
              margin-top: 0.3rem;
              font-size: 0.36rem;
              color: #272727;
            }
            img{
              height: 0.48rem;
            }
          }
          .kh{
            width: 1.2rem;
            img{
              width: 0.72rem;
            }
          }
        }
        .factory_list{
          width: 100%;
          font-size: 0.26rem;
          line-height: 0.32rem;
          color: #272727;
          margin-bottom: 0.3rem;
          .factory_name{
            font-size: 0.28rem;
            line-height: 0.36rem;
          }
          .phone{
            margin-top: 0.25rem;
          }
        }
      }
    }

  }
}
</style>
